import {StyleSheet} from 'react-native';
import {FONTS} from '../../utils/Constants';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    maincontainer: {
      ...CommonStyles.half_min_width,
      ...CommonStyles.full_flex,
      backgroundColor: colors.background,
    },
    formView: {
      paddingBottom: 150,
      ...CommonStyles.ph_56,
      ...CommonStyles.full_flex,
    },
    signinRouteContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.mb_32,
    },
    dotContainer: {
      top: -4,
      ...CommonStyles.flex_row,
      marginBottom: 12,
    },
    marginLeftMinus4: {
      marginLeft: -4,
    },
    marginLeftMinus10: {
      marginLeft: -10,
    },
    activeDot: {
      top: 1,
      marginLeft: -10,
    },
    checkboxList: {
      ...CommonStyles.full_flex,
      ...CommonStyles.mt_22,
    },
    checkbox: {
      width: 17,
      height: 17,
    },
    checkboxTitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      color: colors.textMuted,
    },
    buttonContainer: {
      backgroundColor: colors.surface,
      ...CommonStyles.flex_row,
      ...CommonStyles.justify_center,
      ...CommonStyles.pv_24,
      ...CommonStyles.ph_56,
      ...CommonStyles.absolute_pos,
      ...CommonStyles.b_0,
      ...CommonStyles.r_0,
      ...CommonStyles.l_0,
      borderTopWidth: 1,
      borderColor: colors.borderMuted,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
    },
    saveButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.ml_12,
      ...CommonStyles.max_width_292,
    },
    skipButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.mr_12,
      ...CommonStyles.max_width_292,
    },
  });

export default makeStyles;
